export const LOAD_PACKAGES = 'LOAD_PACKAGES';
export const SET_PACKAGE_PAGINATION = 'SET_PACKAGE_PAGINATION';
export const SET_PACKAGE_SORT = 'SET_PACKAGE_SORT';
export const SET_PACKAGE_FILTER = 'SET_PACKAGE_FILTER';
export const RESET_PACKAGE_FILTERS = 'RESET_PACKAGE_FILTERS';
export const ADD_NEW_PACKAGE = 'ADD_NEW_PACKAGE';
export const LOAD_CONFIGURATIONS_FOR_PACKAGE = 'LOAD_CONFIGURATIONS_FOR_PACKAGE';
export const SET_CONFIGURATION_PAGINATION_FOR_PACKAGE = 'SET_CONFIGURATION_PAGINATION_FOR_PACKAGE';
export const SET_CONFIGURATION_FILTER_FOR_PACKAGE = 'SET_CONFIGURATION_FILTER_FOR_PACKAGE';
export const SET_CONFIGURATION_SORT_FOR_PACKAGE = 'SET_CONFIGURATION_SORT_FOR_PACKAGE';
export const RESET_CONFIGURATION_FILTERS_FOR_PACKAGE = 'RESET_CONFIGURATION_FILTERS_FOR_PACKAGE';
export const SET_CHECKED_CONFIGURATIONS_FOR_PACKAGE = 'SET_CHECKED_CONFIGURATIONS_FOR_PACKAGE';
export const GO_TO_ADD_BULK_PACKAGES_STEP = 'GO_TO_ADD_BULK_PACKAGES_STEP';
export const ADD_TO_BULK_CARTESIANS = 'ADD_TO_BULK_CARTESIANS';
export const ADD_BULK_PACKAGES = 'ADD_BULK_PACKAGES';
export const LOAD_EDITABLE_PACKAGE = 'LOAD_EDITABLE_PACKAGE';
export const EDIT_PACKAGE = 'EDIT_PACKAGE';
export const SET_CONFIGURATIONS_TO_EDITABLE_PACKAGE = 'SET_CONFIGURATIONS_TO_EDITABLE_PACKAGE';
export const SET_EMPTY_EDITABLE_PACKAGE = 'SET_EMPTY_EDITABLE_PACKAGE';
export const TOGGLE_PACKAGE_STATUS = 'TOGGLE_PACKAGE_STATUS';
export const UPDATE_PROGRESS_OF_BULK_PACKAGES = 'UPDATE_PROGRESS_OF_BULK_PACKAGES';
export const FINISH_ADDING_BULK_PACKAGES = 'FINISH_ADDING_BULK_PACKAGES';
